var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.content.type === 'image')?_c('a',{attrs:{"href":_vm.content.url,"target":"_blank"}},[_c('img',{staticClass:"d-block mw-100 carousel-img",attrs:{"src":_vm.content.url}})]):_c('div')}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-67d3c7ce","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CarouselContent.vue
// module id = null
// module chunks = 